export const NavigationEnum = {
    NONE: "none",
    NORMAL: "normal",
    SHOW_ICON: "show-icon",
    SLIDE_LEFT: "slide-left",
    SLIDE_RIGHT: "slide-right",
}

export const NAV = 0;
export const PRIVACY_POLICY = 1;
export const TERMS_OF_USE = 2;
export const MONEY_BACK_POLICY = 3;
export const FAQ = 4;

